export interface IAttachment {
	ParentId?: string;
	Name?: string;
	OwnerId?: string;
	IsPrivate?: boolean;
	ContentType?: string;
	Description?: string;
	Body?: string;
}
